import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import MultiRangeSlider from "./MultiRangeSlider";
import { minBy, maxBy } from "lodash-es";

// @todo, this needs to be broken out into reusable component for slider
export default function MultiRangeFilter({ onChange, filter, domain }) {
  const multiRangeFilters = useSelector(
    (state) => state.layout.multiRangeFilters
  );
  const { type, format, values } = filter;

  // Unless we are using custom values for the ranges, let's grab the smallest
  // and largest number among the values and treat those as the min/max limits.
  const limitMin = useMemo(() => {
    return filter.limitMin ?? minBy(values, (v) => v.value)?.value;
  }, [filter.limitMin, values]);

  const limitMax = useMemo(() => {
    return filter.limitMax ?? maxBy(values, (v) => v.value)?.value;
  }, [filter.limitMax, values]);

  // We are creating on the fly checked values on changes in the reducer
  const [checkedMin, checkedMax] = values.filter((v) => v.checked);
  const checked = {
    min: checkedMin?.value ?? limitMin,
    max: checkedMax?.value ?? limitMax,
  };

  function handleChange(nextMin, nextMax) {
    // Check if the user is selecting the full range (min to max)
    const isFullRange =
      Number(nextMin) === Number(limitMin) &&
      Number(nextMax) === Number(limitMax) &&
      domain === "clife";

    if (filter.min !== nextMin || filter.max !== nextMax) {
      onChange(
        {
          ...filter,
          min: nextMin,
          max: nextMax,
          type: values[0]?.type,
          // If it's the full range, we might want to mark this specially
          isFullRange,
        },
        type
      );
    }
  }

  return (
    <MultiRangeSlider
      onChange={handleChange}
      type={type}
      format={format}
      values={values}
      min={limitMin}
      max={limitMax}
      multiRangeFilters={multiRangeFilters}
      checked={checked}
    />
  );
}
